import { TemplateVariant } from '../domain/enums.js';
import { z } from '../zod.js';
import { RowVersion, Uuid } from './common.js';
import { DocBodyV1, DocPropsV1, JsonObject } from './documents.js';
/**
 * Templates (1.0b deliverable 18; built by 1.S): a type's starting body, props and links.
 * `links` is kept for later phases: Phase 1 templates hold none, and `templates.create` and
 * `templates.update` refuse a non-empty list with 422 `invalid_body` (`links_unsupported`; CS r2c,
 * DECISIONS 141 item 1). Its keys are fixed when the importer or the GM needs them (a CS round).
 */
const Name = z.string().min(1).max(200);
/** A template (`template`); `archived` is from `deleted_at`. */
export const TemplateV1 = z.strictObject({
    id: Uuid,
    docTypeId: Uuid,
    name: Name,
    variant: TemplateVariant,
    body: DocBodyV1,
    bodySchemaVersion: RowVersion,
    props: DocPropsV1,
    links: z.array(JsonObject),
    sortKey: z.string().min(1).max(200).nullable(),
    archived: z.boolean(),
});
/** `templates.list`: one type's templates, or every template when omitted. */
export const TemplatesQueryV1 = z.strictObject({ typeId: Uuid.optional() });
/** `templates.create`. A create appends. */
export const TemplateCreateRequestV1 = z.strictObject({
    docTypeId: Uuid,
    name: Name,
    variant: TemplateVariant,
    body: JsonObject,
    bodySchemaVersion: RowVersion.optional(),
    props: DocPropsV1.optional(),
    links: z.array(JsonObject).optional(),
});
/** `templates.update`: any of these; `afterId` is the template it follows (null: first). */
export const TemplateUpdateRequestV1 = z.strictObject({
    name: Name.optional(),
    variant: TemplateVariant.optional(),
    body: JsonObject.optional(),
    bodySchemaVersion: RowVersion.optional(),
    props: DocPropsV1.optional(),
    links: z.array(JsonObject).optional(),
    afterId: Uuid.nullable().optional(),
});
/**
 * `docs.applyTemplate`: instantiate a template of the document's type into its body, re-minting
 * every block id and `secretId` (baseline section 3, "Identifier ownership").
 */
export const ApplyTemplateRequestV1 = z.strictObject({
    templateId: Uuid,
    baseBodyVersion: RowVersion,
});
//# sourceMappingURL=templates.js.map